module.exports = __webpack_public_path__ + "static/media/i_rank_1.cab9533c.png";